export default __webpack_public_path__ + "static/media/Telemedicine.d4a69eed.svg";